module.exports = __webpack_public_path__ + "media/images/emblems/Rhaezuens_wappen-30f042036c91e12115acaa0e488e6349.svg";